import { createContext } from 'react';

/** Provided by FormRenderer when the host supplies onResolveInjectedData. */
export const InjectedDataContext = createContext<
  ((injectionType: string) => Promise<string>) | undefined
>(undefined);
